import { render, staticRenderFns } from "./RolesAddEdit.vue?vue&type=template&id=7dc88bd4&scoped=true&"
import script from "./RolesAddEdit.vue?vue&type=script&lang=js&"
export * from "./RolesAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./RolesAddEdit.vue?vue&type=style&index=0&id=7dc88bd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc88bd4",
  null
  
)

export default component.exports